import { MessagesInterface } from '../../../general/model';

export const Messages = {
  removeError: (message: string) => ({
    title: `We have a problem deleting some items`,
    message,
  }),
} as MessagesInterface;

export type RemoverShape = {
  bulkJobID: null | string;
  isOpen: boolean;
  inProgress: boolean;
  files: number;
  folders: number;
};
export const initialState: RemoverShape = {
  bulkJobID: null,
  isOpen: false,
  inProgress: false,
  files: 0,
  folders: 0,
};
